;(function($, undefined){
    "use strict";

    var rnn, log;

    function printme() {
        window.print();
    }

    function initSocialButtons() {
        // We need to remove the existing Email from Social Media Icons
        // - may be removed in the fragment later
        $('.newsEntry .shareTools li.emailfoot').hide();

        $('.shareTools a, .ad-save-share a').on('click', function (e) {
            var toolOption;

            toolOption = this.hash;

            if (toolOption === '#print') {
                e.preventDefault();
                printme();
            }
        });
    }

    rnn = window.rnn;
    log = rnn.logging.log;

    rnn.modules.register("social", {
        init: initSocialButtons
    });

})(jQuery);
